import { useState } from "react";
import "./Footer.css"
import { useNavigate } from "react-router-dom"
import {Spinner} from "react-bootstrap"
import axios from "axios"

function Footer() {
    const [email, setEmail] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()

    const formSubmitHandler = (e) => {
        e.preventDefault();
        setLoading(true);
        axios
          .post("/send-newsletter", {
            email: email,
            formType: "Newsletter",
          })
          .then((response) => {
            if (response.data.msg === "success") {
              setError(false);
              setSuccess("Newsletter Subscribed Successfully!");
              setLoading(false);
              // setEmail("");
              navigate("/thank-you-subscribe");
            } else if (response.data.msg === "fail") {
              setSuccess(false);
              setError("Email failed to send, try again by reloading the page.");
              setLoading(false);
              setEmail("");
            }
          });
      };

  return (
    <div className="footer-container">

        {/* newsletter Upper section */}
        {/* <div className="upper-newsletter-container container">
            <div className="text-container">
                <div className="newsletter-logo">
                    <img loading="lazy"  src="/images/icons/newslater.png" alt="newsletter" />
                </div>
                <div className="text-content">
                    <h3>Subscribe to Lotus Accounting</h3>
                    <p>Enter your email to stay informed with the updates regarding tax and accounting services</p>
                </div>
            </div>
            <div className="newsletter-main-form">
                  <form className="newsletter-form" onSubmit={formSubmitHandler}>
                    <input 
                        required
                        type="email"
                        value={email}
                        maxLength="36"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email" 
                    />
                    <button type="submit"><span className="subscribe-btn-text">Subscribe</span> <img loading="lazy" src="/images/icons/Icon-feather-bell.svg" alt="bell" /></button>
                    </form>
                    {loading ? (
                      <div className="row pb-4">
                        <div className="col-12">
                          <Spinner
                            animation="border"
                            role="status"
                            style={{ color: "white" }}
                          />
                        </div>
                      </div>
                    ) : (
                      success ? (
                        <div>
                          {setLoading(false)}
                          {setSuccess(false)}
                        </div>
                      ) : (
                        error && (
                          <div>
                            {setLoading(false)}
                            {alert(error)}
                            {setError(false)}
                          </div>
                        )
                      )
                    )}

            </div>
        </div> */}

        {/* div for border lining */}
        {/* <div className="line-seprator container"></div> */}

        {/* middle section */}

        {/* <div className="middle-links-container container">
            <div className="left">
                <img loading="lazy" src="images/icons/logo.png" alt="logo" onClick={()=>{navigate("/home")}} style={{cursor:"pointer"}}/>
                <p className="body-paragraph mt-4" style={{color : "#FFFFFF",fontSize:".7rem"}}>A full-service bookkeeping, accounting, and tax firm dedicated to delivering tailored and superior financial solutions.</p>
            </div>
            <div className="right">
                <ul className="right-upper flex-column flex-sm-row text-center gap-md-4 gap-3 justify-content-md-between justify-content-center">
                <li onClick={()=>{navigate("/home")}}>Home</li>
                    <li onClick={()=>{navigate("/about")}}>About</li>
                    <li onClick={()=>{navigate("/services")}}>SERVICES</li>
                    <li onClick={()=>{navigate("/contact")}}>Contact</li>
                </ul>
                <ul className="right-bottom d-flex flex-column flex-lg-row align-items-center  align-items-md-start align-items-lg-center justify-content-lg-start justify-content-center px-md-0 px-2 py-lg-0 py-3">
                    <li>
                        <img loading="lazy" src="images/icons/footer-phone.svg" alt="phone" />
                        <a href="tel:+14169042013">+14169042013</a>
                    </li>
                    <li>
                        <img loading="lazy" src="images/icons/footer-mail.svg" alt="mail" />
                        <a href="#">info@lotusaccounting.ca</a>
                    </li>
                    <li>
                        <img loading="lazy" src="images/icons/footer-location.svg" alt="address" />
                        <a href="#">Suite 304-305 Milner Ave. Toronto, ON M1B 3V4</a>
                    </li>
                </ul>
                <ul className="lower-link-list justify-content-md-start justify-content-center pl-0">
                   
                    <li><img loading="lazy" src="images/icons/Rectangle-1402.png" alt="shape" /></li>
                   
                    <li><img loading="lazy" src="images/icons/Rectangle-1404.png" alt="shape" /></li>
                </ul>
            </div>
        </div> */}
        <div className="middle-links-container container">
          <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3">
              <div className="left w-100">
                  <img loading="lazy" src="images/icons/logo.png" alt="logo" onClick={()=>{navigate("/home")}} style={{cursor:"pointer"}}/>
                  <p className="body-paragraph mt-4 px-lg-0 px-3" style={{color : "#FFFFFF",fontSize:"1.1rem",width:"100%"}}>A full-service bookkeeping, accounting, and tax firm dedicated to delivering tailored and superior financial solutions.</p>
                  <div className="lower-link-list justify-content-md-start justify-content-center pl-0 gap-4">
                    
                      <><img loading="lazy" src="images/icons/Rectangle-1402.png" onClick={()=>{window.open("https://www.facebook.com/profile.php?id=100046316481974","blank")}} alt="icon" className="me-3" style={{width:"30px",cursor:"pointer"}} /></>
                    
                      <><img loading="lazy" src="images/icons/Rectangle-1404.png" onClick={()=>{window.open("https://www.instagram.com/lotusaccounting/","blank")}} alt="icon" style={{width:"30px",cursor:"pointer"}} /></>
                      <><img loading="lazy" src="images/icons/li-icon.png" onClick={()=>{window.open("https://www.linkedin.com/company/lotus-accounting/?viewAsMember=true","blank")}} alt="icon" className="ms-3" style={{width:"30px",cursor:"pointer"}} /></>
                  </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="d-flex flex-lg-row right ps-4 ">

                  <ul className="right-upper flex-column text-lg-start text-center gap-md-4 gap-3 justify-content-md-between justify-content-center">
                    <h3 className="body-heading" style={{fontSize:"1.3rem",color:"white"}}>Quick Links</h3>
                      <li onClick={()=>{navigate("/about")}}>About</li>
                  <li onClick={()=>{navigate("/outsourced-services")}}>Outsourced Services</li>
                      <li onClick={()=>{navigate("/consulting-services")}}>Consulting Services</li>
                      <li onClick={()=>{navigate("/accounting-taxes")}}>Accounting & Taxes</li>
                  </ul>
                  <ul className="right-bottom d-flex ps-lg-4 flex-column align-items-center  align-items-md-start align-items-lg-start justify-content-lg-start justify-content-center px-md-0 px-2 py-lg-0 py-3">
                    <h3 className="body-heading" style={{fontSize:"1.3rem",color:"white"}}>Get In Touck</h3>
                      <li>
                          <img loading="lazy" src="images/icons/footer-phone.svg" alt="phone" />
                          <a href="tel:+14169042013">+14169042013</a>
                      </li>
                      <li>
                          <img loading="lazy" src="images/icons/footer-mail.svg" alt="mail" />
                          <a href="#">info@lotusaccounting.ca</a>
                      </li>
                      <li>
                          <img loading="lazy" src="images/icons/footer-location.svg" alt="address" />
                          <a href="#">Suite 304-305 Milner Ave. Toronto, ON M1B 3V4</a>
                      </li>
                  </ul>
                  
              </div>
            </div>

            <div className="col-lg-2 d-flex align-items-start justify-content-center ">
              {/* <img alt="logo" loading="lazy" src="/images/icons/cpa-logo.png" className="img-fluid" alt="cpa logo" /> */}
              <img loading="lazy" src="/images/icons/cpao-logo.svg" style={{width:"130px"}} className="img-fluid" alt="cpa logo" />
            </div>


          </div>
          </div>
        </div>

        {/* Lower sections */}

        <div className="lower-container ">
            <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center">
                <div><small style={{color:"#242424"}}>© Copyright {new Date().getFullYear()} Lotus Accounting Services Inc - All Rights Reserved <span className="divider">| </span></small>
    <span 
      className="footer-policy-link"
      style={{cursor:"pointer",color:"#242424"}}
      onClick={() => navigate("/privacy-policy")}
    >
      <small>Privacy Policy</small>
    </span>
    <span className="divider"> | </span>
    <span 
      className="footer-policy-link"
      style={{cursor:"pointer",color:"#242424"}}
      onClick={() => navigate("/terms-of-services")}
    >
      <small>Terms of Services</small>
    </span>
    </div>
                <small style={{color:"#242424"}}>Made With ❤️ By <a href="https://www.creativesquad.ca/" target="blank" style={{color:"#242424"}}>Creative Squad</a></small>
                
            </div>
        </div>
        
    </div>
  )
}

export default Footer